import { jsx } from 'react/jsx-runtime';
import { Box } from '../Box/Box.mjs';
import { Flex } from '../Flex/Flex.mjs';

const CardBody = (props) => {
    return (jsx(Box, { paddingLeft: 3, paddingRight: 3, paddingTop: 2, paddingBottom: 2, children: jsx(Flex, { ...props, alignItems: "flex-start" }) }));
};

export { CardBody };
